import React from 'react';
import { useTranslation } from 'react-i18next';
import { Phone, Mail, MapPin } from 'lucide-react';
import './ContactInfoCards.css';

const ContactInfoCards = () => {
  const { t } = useTranslation();
  const cards = [
    {
      icon: Phone,
      title: t('contact_info_phone_title'),
      value: '+91-7019914021'
    },
    {
      icon: Mail,
      title: t('contact_info_email_title'),
      value: 'atmasakshifoundation1@gmail.com'
    },
    {
      icon: MapPin,
      title: t('contact_info_address_title'),
      value: t('contact_info_address_value')
    }
  ];

  return (
    <section className="contact-info-cards section-padding">
      <div className="container">
        <div className="cards-grid">
          {cards.map((card, index) => {
            const IconComponent = card.icon;
            return (
              <div key={index} className={`info-card fade-up stagger-${index + 1}`}>
                <div className="card-icon-wrapper">
                  <IconComponent size={32} className="card-icon" />
                </div>
                <h3 className="card-title">{card.title}</h3>
                <p className="card-value">{card.value}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ContactInfoCards;
